import { defineStore } from 'pinia';
import { Howler } from 'howler';

import audio from '@/common/audio';
import { checkIsInGame, gamePromise } from '@/utils/game'
const { CDN } = process.env;

interface Config {
  isMuted: boolean;
}
const configState = (): Config => ({
  isMuted: false,
});

const useConfig = defineStore('config', {
  state: configState,
  actions: {
    // BY Mini
    updateIsMuted(bool: boolean) {
      // 所有音效靜音切換
      // this.isMuted = bool;
      // Howler.mute(bool);
      // // 背景音樂播放切換
      // if (bool) {
      //   audio.bgm.pause();
      // } else {
      //   audio.bgm.play();
      // }
    },

    toggleIsMuted() {
      // // 紀錄用戶自主切換的狀態
      // localStorage.setItem('MUTED', JSON.stringify(!this.isMuted));
      // this.updateIsMuted(!this.isMuted);
    },

    audioWatcher() {
      // BY Mini
      // 當離開活動視窗時音效需暫停
      // document.addEventListener('visibilitychange', () => {
      //   if (document.visibilityState === 'visible' && !this.isMuted) {
      //     audio.bgm.play();
      //   } else {
      //     audio.bgm.stop();
      //   }
      // });
    },
    async checkInGameVolume() {
      // if (checkIsInGame()) {
      //   // 遊戲內依據客戶端的音量做播放
      //   const volume = await gamePromise('Volume', 'music');

      //   if (volume === '0') {
      //     this.updateIsMuted(true);
      //   } else {
      //     this.updateIsMuted(localStorage.getItem('MUTED') === 'true');
      //     Howler.volume(Number(volume));
      //   }
      // } else {
      //   // 遊戲外自動播放
      //   this.updateIsMuted(localStorage.getItem('MUTED') === 'true');
      // }
    },
    async checkAudio() {
      // this.audioWatcher();
      // await this.checkInGameVolume();
    },
  },
});

export default useConfig;
